import React from 'react';
import CarSlider from './slider';
import './index.css';

class Setup extends React.Component {
  handlerOnSliderClick = (color) =>{
    this.props.onChangeColor(color)
  }
  render() {
    return (
      <section className="setup">
          <h2 className="setup__title">Setup your Stallion</h2>
          <CarSlider onSliderChangeColor={this.handlerOnSliderClick}/>
      </section>
    );
  }
}

export default Setup;
